
import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/hooks/AuthContext";
import { useUserDetails } from "./user-details/useUserDetails";
import { UserDetailsLoading } from "./user-details/UserDetailsLoading";
import { UserDetailsError } from "./user-details/UserDetailsError";
import { UserDetailsContent } from "./user-details/UserDetailsContent";

export const UserDetails: React.FC = () => {
  const navigate = useNavigate();
  const { profile: currentUserProfile } = useAuth();
  const {
    id,
    user,
    assignments,
    timeEntries,
    loading,
    loadingTimeEntries,
    fetchTimeEntries,
    handleDelete
  } = useUserDetails();

  const isAdmin = currentUserProfile?.role === 'admin';

  const handleBack = () => {
    navigate("/gestion/users");
  };

  const handleEdit = () => {
    navigate(`/gestion/users/edit/${id}`);
  };

  const handleDeleteUser = async () => {
    const success = await handleDelete();
    if (success) {
      navigate("/gestion/users");
    }
  };

  const handleAddAssignment = () => {
    navigate(`/gestion/users/details/${id}/add-assignment`);
  };

  if (loading) {
    return <UserDetailsLoading onBack={handleBack} />;
  }

  if (!user) {
    return <UserDetailsError onBack={handleBack} />;
  }

  return (
    <UserDetailsContent
      user={user}
      assignments={assignments}
      timeEntries={timeEntries}
      loadingTimeEntries={loadingTimeEntries}
      isAdmin={isAdmin}
      onBack={handleBack}
      onEdit={handleEdit}
      onDelete={handleDeleteUser}
      onAddAssignment={handleAddAssignment}
      onFetchTimeEntries={fetchTimeEntries}
    />
  );
};
